<template>
  <div class="q-py-xl">
    <div class="text-center text-vibrant-purple text-weight-bold" style="font-size: 2.2rem">
      Real-time data & analytics for your portfolio
    </div>
    <div class="text-center text-grey-9 q-mb-xl text-subtitle1" style="margin: 0 auto">
      Leverage daily data and insights from more than 5 million multifamily properties and gain an
      edge on your competition
    </div>
  </div>
  <div class="subscribe-property-reports">
    <q-spinner v-if="trialConsumed === null" class="text-h4 text-center full-width" />
    <checkout-card
      v-else
      plan-name="Property Reports"
      :price="300"
      :trial-days="trialConsumed ? 0 : 7"
      @create-subscription="createSubscription"
    >
      <div>
        <div class="text-weight-medium">
          {{ trialConsumed ? 'Resume Your Subscription' : 'Professional Plan' }}
        </div>
        <div :class="[$q.dark.isActive ? 'text-grey-4' : 'text-grey-9']">
          {{ trialConsumed ? '$300/mo' : '7-day free trial' }}
        </div>
        <div v-if="!trialConsumed" :class="[$q.dark.isActive ? 'text-grey-4' : 'text-grey-9']">
          Then $300.00 per month
        </div>
      </div>
    </checkout-card>
  </div>
</template>

<script lang="ts">
import { useStripeStore } from '@/stores/stripe'
import CheckoutCard from '@/components/CheckoutCard.vue'
import type { BillingAddress } from 'common'

export default {
  name: 'SubscribePropertyReportsView',
  components: {
    CheckoutCard
  },
  computed: {
    trialConsumed() {
      return useStripeStore().propertyReportTrialConsumed
    }
  },
  methods: {
    async createSubscription(payload: {
      paymentId: string
      couponId?: string
      address?: BillingAddress
      cb: () => void
      failCb: () => void
    }) {
      const sub = await useStripeStore().createPropertyReportsSubscription(
        payload.paymentId,
        payload.couponId,
        payload.address
      )
      if (sub) {
        payload.cb()
      } else {
        payload.failCb()
      }
    }
  }
}
</script>
<style scoped>
.subscribe-property-reports {
  max-width: 1280px;
  margin: auto;
}
.text-vibrant-purple {
  color: #4f46e5;
}
</style>
